import type { ITourismInformationCenterOption } from "@/types/DestinationProvider.types"

/**
 * Décode le paramètre `source` des campagnes Dahub (account_id du TIC en base64).
 */
export function decodeDialogueCampaignSource(source: string): string | null {
  try {
    let base64 = source.trim().replace(/-/g, "+").replace(/_/g, "/")

    while (base64.length % 4) {
      base64 += "="
    }

    const decoded = atob(base64).trim()

    return decoded || null
  } catch {
    return null
  }
}

/**
 * Retrouve l'OT ciblé via son account_id Dahub.
 */
export function findTicIdForCampaignSource(
  tourismInformationCenters: ITourismInformationCenterOption[],
  accountId: string
): number | null {
  const normalized = accountId.trim()

  if (!normalized) {
    return null
  }

  const exactMatch = tourismInformationCenters.find(
    (tic) => tic.account_id != null && String(tic.account_id) === normalized
  )

  if (exactMatch) {
    return exactMatch.id
  }

  const numericAccountId = Number(normalized)

  if (!Number.isFinite(numericAccountId)) {
    return null
  }

  const numericMatch = tourismInformationCenters.find(
    (tic) => tic.account_id != null && Number(tic.account_id) === numericAccountId
  )

  return numericMatch?.id ?? null
}
